import { render, staticRenderFns } from "./Campains.vue?vue&type=template&id=4f0d05ce&scoped=true"
import script from "./Campains.vue?vue&type=script&lang=js"
export * from "./Campains.vue?vue&type=script&lang=js"
import style0 from "./Campains.vue?vue&type=style&index=0&id=4f0d05ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d05ce",
  null
  
)

export default component.exports